import { ERROR_STATE_COPY } from "@/components/errorState/constants";
import { NormalText } from "@/components/text/NormalText";
import { ToastSupportFooter } from "@/components/ToastSupportFooter";

// Toast body for a request that failed while the browser was online. Same copy as the connection error screen, so the VPN advice support leads with reads the same everywhere.
export function ConnectionErrorToastContent(): React.ReactNode {
  return (
    <div>
      <NormalText elementType="p" className="font-bold">
        {ERROR_STATE_COPY.connection.heading}
      </NormalText>
      <NormalText elementType="p">
        {ERROR_STATE_COPY.connection.body}
      </NormalText>
      <ToastSupportFooter lead="If it keeps happening, please" />
    </div>
  );
}
